import pageType from 'Addons/search/pageType';

export default {
  page: {
    typeToSelectorMap: {
      [pageType.home]: '#home, body.home-page',
      [pageType.category]: '#category',
      [pageType.brand]: 'body.search-groups',
      [pageType.product]: 'input#catalogid[name="item_id"]',
    },
  },
};
